import * as types from "../constants";

const initialState = {
  isLoading: true,
  error: null,
  items: [],
};

export default function shareClassesISINReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_SHARE_CLASSES_ISIN_INIT:
      return { ...state, error: null, isLoading: true };

    case types.GET_SHARE_CLASSES_ISIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        items: action.data.data,
        fundId: action.data.fundId,
      };

    case types.GET_SHARE_CLASSES_ISIN_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.notification.system_message,
      };

    default:
      return state;
  }
}
